import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import ContentStore from 'stores/Content.store';
import styles from './ForInvestors.module.scss';
import { Container, Title } from 'common/components/Layout/Layout';
import PrimaryButtonComponent from 'common/components/PrimaryButtonComponent/PrimaryButtonComponent';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import { ANCHOR } from 'common/consts/common';
import LanguageService from 'services/Language.service';
import News from './components/News';
import UpcomingEvents from 'common/components/UpcomingEvents/UpcomingEvents';
import Newsletter from './components/Newsletter';
import ContactForInvestors from './components/ContactForInvestors';
import SideMenu from './components/SideMenu';
import messages from './ForInvestors.intl';
import LatestCurrentReports from './components/LatestCurrentReports';
import StockPriceChart from './components/StockPriceChart';

const NEWEST_EVENTS_LIMIT = 5;

@injectIntl
@observer
export default class ForInvestors extends Component {
  state = {
    language: LanguageService.getLang()
  };

  render() {
    if (!ContentStore.isLoaded) {
      return null;
    }
    const { content } = ContentStore;
    const { ForInvestors: upcomingEventData } = content;

    return (
      <div className={styles.ForInvestorsViews}>
        <Container>
          <Title
            className={styles.Title}
            title={this.props.intl.formatMessage(messages.title)}
          />
        </Container>
        <Container>
          <div className={`${styles.ContainerArticle} `}>
            <StockPriceChart />
            <LatestCurrentReports />
            <News />
            <UpcomingEvents
              upcomingEventData={upcomingEventData.slice(
                0,
                NEWEST_EVENTS_LIMIT
              )}
              displayTitle
            />
            <div className={styles.ButtonWrapper}>
              <Link to={ANCHOR.PLANNED_EVENTS[this.state.language]}>
                <PrimaryButtonComponent
                  text={this.props.intl.formatMessage(messages.eventsButton)}
                />
              </Link>
            </div>
            <Newsletter />
          </div>
          <div className={`${styles.SideMenuWrapper}`}>
            <SideMenu />
          </div>
        </Container>
        <Container>
          <div className={`${styles.ContactForInvestorsWrapper}`}>
            <ContactForInvestors />
          </div>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ForInvestors/ForInvestors.js